document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.estado').forEach(function(element) {
        var estadoId = element.getAttribute('data-estado');

        // Use AJAX to check if there are entries for the current estado
        jQuery.ajax({
            url: custom_ajax_params.ajaxurl,
            type: 'POST',
            data: {
                action: 'check_entries_for_estado',
                estado: estadoId,
                security: custom_ajax_params.nonce,
            },
            success: function(response) {
                var hasEntries = JSON.parse(response);

                if (hasEntries) {
                    // Add a class to the estado with associated entries
                    element.classList.add('has-entries');
                } else {
                    // Add a class to the estado without entries
                    element.classList.add('no-entries');
                }
            },
            error: function(error) {
                console.error('Error checking entries for estado:', estadoId);
                console.log(error);
            }
        });

        element.addEventListener('click', function(e) {
            e.preventDefault();
            var selectedEstado = this.getAttribute('data-estado');

            // Use AJAX to fetch post ID based on estado
            jQuery.ajax({
                url: custom_ajax_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'get_post_id_by_estado',
                    estado: selectedEstado,
                    security: custom_ajax_params.nonce,
                },
                success: function(response) {
                    var postInfo = JSON.parse(response);

                    // Check if post ID is found
                    if (postInfo.post_id !== 0) {
                        // Add a class to the selected estado
                        document.querySelectorAll('.estado').forEach(function(el) {
                            el.classList.remove('selected'); // Remove the class from all states
                        });
                        element.classList.add('selected'); // Add the class to the selected state

                        // Use AJAX to fetch information from WordPress using the retrieved post ID
                        jQuery.ajax({
                            url: custom_ajax_params.ajaxurl,
                            type: 'POST',
                            data: {
                                action: 'get_fornecedores_info',
                                post_id: postInfo.post_id,
                                estado: selectedEstado,
                                security: custom_ajax_params.nonce,
                            },
                            success: function(response) {
                                var fornecedorInfo = JSON.parse(response);

                                // Display information on the page
                                document.querySelector('.sellers-state').textContent = selectedEstado;
                                document.querySelector('.sellers-list').innerHTML = '<p><strong>Nome:</strong> ' + fornecedorInfo.nome + '</p><p><strong>Email:</strong> ' + fornecedorInfo.email + '</p><p><strong>Telefone:</strong> ' + fornecedorInfo.telefone + '</p>';
                            },
                            error: function(error) {
                                console.error('Error fetching Fornecedores information');
                                console.log(error);
                            }
                        });
                    } else {
                        console.error('No post found for estado:', selectedEstado);
                    }
                },
                error: function(error) {
                    console.error('Error fetching post ID');
                    console.log(error);
                }
            });
        });
    });
});
